<div id='post-submit'>

	<app-post-submit-verification *ngIf='formService.postSubmitStep === "verification"' [@slideInOut]></app-post-submit-verification>

	<app-post-submit-third-party *ngIf='formService.postSubmitStep === "thirdPartyQuestions" && formService.questions?.length' [@slideInOut]></app-post-submit-third-party>

	<app-thank-you-step *ngIf='formService.postSubmitStep === "thankYou"' [@slideInOut]></app-thank-you-step>

</div>
